module.exports = __webpack_public_path__ + "img/3.240c594f.png";